<template>
  <v-sheet>
    <headline-bar>
      <template v-slot:prepend-btn>
        <v-btn icon @click.stop="dismissSideSheet">
          <v-icon>{{
            sideSheetIsOn && $vuetify.breakpoint.xs ? icons.back : icons.close
          }}</v-icon>
        </v-btn>
      </template>

      Change password
    </headline-bar>

    <v-form
      ref="changePasswordForm"
      @submit.prevent="submitHandler"
      class="pa-6 flex-grow-1"
    >
      <v-text-field
        v-model="user.currentPassword"
        :rules="currentPasswordRules"
        :type="passwordVisible ? 'text' : 'password'"
        tabindex="1"
        label="Current password"
        required
        validate-on-blur
        filled
        color="secondary"
        autofocus
      ></v-text-field>
      <v-text-field
        v-model="user.newPassword"
        :rules="newPasswordRules"
        :type="passwordVisible ? 'text' : 'password'"
        tabindex="2"
        label="New password"
        required
        validate-on-blur
        filled
        color="secondary"
      ></v-text-field>
      <v-text-field
        v-model="user.confirmNewPassword"
        :rules="confirmNewPasswordRules"
        :type="passwordVisible ? 'text' : 'password'"
        tabindex="3"
        label="Confirm new password"
        required
        validate-on-blur
        filled
        color="secondary"
      ></v-text-field>
      <v-checkbox v-model="passwordVisible" label="Show password"></v-checkbox>
      <v-btn
        :light="$vuetify.theme.dark"
        :dark="!$vuetify.theme.dark"
        type="submit"
        class="float-right"
      >
        Submit
      </v-btn>
    </v-form>
  </v-sheet>
</template>

<script>
export default {
  data() {
    return {
      passwordVisible: false,

      valid: false,
      user: {
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
      },
      currentPasswordRules: [],
      newPasswordRules: [
        (value) => !!value || "Required.",
        (value) => value.length >= 6 || "At least 6 characters.",
      ],
      confirmNewPasswordRules: [
        (value) => !!value || "Required.",
        (value) => value.length >= 6 || "At least 6 characters.",
      ],
    };
  },

  computed: {
    sideSheetIsOn() {
      return this.$store.getters["SideSheet/isOn"];
    },

    accountInfo() {
      return this.$store.getters["Profile/accountInfo"];
    },
  },

  watch: {
    "user.currentPassword"() {
      this.currentPasswordRules = [];
    },
  },

  methods: {
    dismissSideSheet() {
      this.$store.dispatch("SideSheet/toggleSideSheet", { isOn: false });
    },

    submitHandler() {
      this.currentPasswordRules = [
        (value) => !!value || "Required",
        (value) =>
          value === this.accountInfo.password.value ||
          "Current password is incorrect",
      ];
      this.confirmNewPasswordRules.push(
        (value) => value === this.user.newPassword || "Passwords do not match."
      );

      setTimeout(() => {
        if (this.$refs.changePasswordForm.validate()) {
          // Submit this form
          this.$store.dispatch("Profile/passwordChange", {
            user: this.user,
          });
          console.log('New password: ' + this.user.newPassword);
          this.dismissSideSheet();
        }
      });
    },
  },

  mounted() {
    this.sideSheet = this.sideSheetIsOn;
  },
};
</script>

<style lang="sass" scoped>
// Need at least 1 line of comment or style to make the "comp-style-overrides/" work
</style>
